
import React from 'react';

import ReactDOM from 'react-dom';
import { Layout} from 'element-react';
import { Button,Table,Pagination} from '@jd/find-react';
 

import KeeVue from '../base/KeeVue.js'
import FeasComponents from '../render/FeasComponents.js'

import FsTableCol from './FsTableCol.js'

import $ from 'jquery';


 


export default class FsTable extends KeeVue {
  constructor(props) {
         super(props);

			this.state =  {

				randId: this.getRandString(),

				pagination: {
					total: 0,
					rows: 10,
					page: 1,
					totalPage: 0,
				},
				sort: 'id',
				order: 'desc',
				groupby: '',
				listName: '',
				isShowGrid: false,
				pageSize: 10,
				pageSizes:[10,20,30,50],
				currentPage4: 1,
				height: 500,
				gridData: [],
				hasFixedField: false,
				componentState: {
					refreshTime: 0
				},
				showType: "grid", // 是否采用grid，或card方式显示
				configWindow: null,
				dtoFields: '',
				selectedRows: [],
				
				selectedRowKeys:[],
				myQueryData: {},
				isLoaded: true,
				inited: false,
				downloadPath:'',

				columns:[],
			}

}

componentDidMount(){
	
			this.registComponent();
			let that = this;
			if(this.props.debug !== true) {
				this.initPo();
				  
				if(this.props.po  && this.isNotBlank(this.props.component.cp.field)) {
				// alert("显示表格!!!!!!!!!!!!")
				 
				 setTimeout(()=>{
					// this.showData(this.props.po);
				 },100)
					
					
				} else {

					this.query();
				}
				this.state.inited = true;

			} else {
				this.state.gridData = [{}];
			}
			// if(that.props.component.cp.isPager !== false || that.props.component.cp.showType === 'tree') {
			// 	setTimeout(function() {
			// 		that.resizeHeight();
			// 	}, 300);
			// 	that.onEvent("keeResize", that.resizeHeight);
			// }
			
			
			setTimeout(()=>{
				this.sendPageEvent("mounted");
			},50);
			
			 
		}
componentWillReceiveProps(nextProps){
						//	  console.log("触发fs-table：url:")
				// alert("nextProps:"+nextProps.component.value);	
				
				
			 
				// if(nextProps.component.value!=this.props.component.value)
				{
					if(typeof nextProps.component.value =="string")
					{
						if(JSON.stringify(this.getGridFormData())==JSON.stringify(nextProps.component.value))
						{
							
						}
						else
						{
							if(nextProps.component.value)
							{
								this.showData(JSON.parse(nextProps.component.value));
							} 
						}
						
					}
					else
					{
						if(JSON.stringify(this.getGridFormData())==JSON.stringify(nextProps.component.value))
						{
							
						}
						else
						{
							this.showData(nextProps.component.value);
						} 
					}
					
					
				}
					 
			}
			objectSpanMethod=({ row, column, rowIndex, columnIndex })=>{
				if(typeof this.spanMethod !=='undefined')
				{
					return this.spanMethod(row, column, rowIndex, columnIndex);
				}
			}
			sortChange=( column, prop, order )=>{
				// console.log(JSON.stringify(column));
				// console.log(JSON.stringify(prop));
				// console.log(JSON.stringify(order));
			}
			upRow=(row)=> {
				let newRow = {};
				let index = this.state.gridData.indexOf(row);
				if(index>0)
				{
					this.state.gridData.remove(row);
					this.state.gridData.insert(index-1,row);
					for(let i = 0; i < this.state.gridData.length; i++) {
						this.state.gridData[i].sn = i + 1;
						this.initComponentValue(this.state.gridData[i].component.child, this.state.gridData[i]);
					}
				}
				// this.showData({rows:JSON.parse(JSON.stringify(this.state.gridData))});
				this.setState({
					gridData:[...this.state.gridData]
				})
				 
			}
			downRow=(row)=> {
				let newRow = {};
				let index = this.state.gridData.indexOf(row);
				if(index<this.state.gridData.length-1)
				{
					this.state.gridData.remove(row);
					this.state.gridData.insert(index+1,row);
					for(let i = 0; i < this.state.gridData.length; i++) {
						this.state.gridData[i].sn = i + 1;
						this.initComponentValue(this.state.gridData[i].component.child, this.state.gridData[i])
					}
				}
				let newSrot = "";
				for(let i = 0; i < this.state.gridData.length; i++) {
					newSrot+=this.state.gridData[i].name+this.state.gridData[i].id+","; 
				}
				 
				// this.showData({rows:JSON.parse(JSON.stringify(this.state.gridData))});
				
				this.setState({
					gridData:[...this.state.gridData]
				})
				
				 
			}
			addRow=(row,pos)=> {
				let newRow = {
					id:this.getRandString(),
				};
				 
				
				if(row )
					for(let p in row) {
						newRow[p] = null;
					}
				if(pos)
				{
					for(let p in row) {
						newRow[p] = row[p];
					}
					
					newRow.id = this.getRandString();
				}
				
				newRow.rowid = newRow.id;
					
				if(this.state.gridData.length===0)
				{
					let str = JSON.stringify(this.props.component);
					newRow.component = JSON.parse(str);
				}
				else
				{
					let str = JSON.stringify(this.state.gridData[0].component);
					newRow.component = JSON.parse(str);
				}
				this.initComponentValue(newRow.component.child, newRow);
				
				if(pos)
				{
					if(pos=='first' ) {
						this.state.gridData.append(-1, newRow);
					} else {
						this.state.gridData.push(newRow);
					}
				}
				else
				{
					if(row ) {
						this.state.gridData.append(this.state.gridData.indexOf(row), newRow);
					} else {
						this.state.gridData.push(newRow);
					}
				}
				
				for(let i = 0; i < this.state.gridData.length; i++) {
					this.state.gridData[i].sn = i + 1;
				}
				
				this.showData({rows:JSON.parse(JSON.stringify(this.state.gridData))});
				
				//alert(newRow.id); 
				return newRow;
				
			}
			removeRow=(row)=> {
				
				
				 
				this.state.gridData.remove(row);
				for(let i = 0; i < this.state.gridData.length; i++) {
					this.state.gridData[i].sn = i + 1;
				}
				this.showData({rows:JSON.parse(JSON.stringify(this.state.gridData))});
				
				if(window.isReport)
				{
					if(this.state.gridData.length==0)
					{
						this.addRow();
					}
				}
			}
			onCommand=(cmdName, item, po, thisForm, parentForm)=> {
				if(cmdName === "change") {
					if(this.state.gridData ) {
						for(let i = 0; i < this.state.gridData.length; i++) {
							this.updateValueFromComponent(this.state.gridData[i], this.state.gridData[i].component.child,this.state.gridData[i].id);
						}
					}
					
					if(this.props.po!==null&&this.props.component.cp.field)
					{
						// alert(this.props.component.cp.field+":"+JSON.stringify(this.getGridFormData()));
						this.setVueAttr(this.props.po, this.props.component.cp.field,this.getGridFormData() );
						this.component.value=this.getGridFormData();
					}
				}
				  
				this.$emit("command", cmdName, item, po, thisForm, parentForm);
				 
					
				 
				
			}
			initPo=()=> {
				let that = this;
				if(this.props.po  && this.isNotBlank(this.props.component.cp.field)) {
					//alert(JSON.stringify(this.props.po));
					//alert(this.props.component.cp.field);
					let rows = this.getValueByAttr(this.props.po, this.props.component.cp.field);
					if(typeof rows ==="string")
					   rows = JSON.parse(rows);
					if(rows) {
						if(rows  && rows instanceof Array) {
							let data = {
								rows: rows
							};
							let str = JSON.stringify(that.props.component);
							for(let i = 0; i < data.rows.length; i++) {
								data.rows[i].component = JSON.parse(str);
								this.initComponentValue(data.rows[i].component.child, data.rows[i])
							}
							console.log("采用po方式处理的数据：" + JSON.stringify(data));
							that.showData(data);
						}
					} else {
						that.showData([]);
					}
				}
			}
			initComponentValue=(componentArray, postData)=> {
				if(componentArray ) {
					for(let i = 0; i < componentArray.length; i++) {
						let c = componentArray[i];
						if(componentArray!==postData.component.child)
						{
							c.id=c.id+postData.id;
						}
						c.rowid = postData.id;
						
						//console.log("fs-table:"+c.name+" :c.rowid="+c.rowid);
						
						if(typeof c.cp.editable === "undefined")
						{
							c.cp.editable = this.editable;
						}
						if(c.name === 'fs-form') {
							if(c.templateForm === null) {
								let childForm = JSON.parse(JSON.stringify(c));
								c.templateForm = childForm;
							}
							if(this.isNotBlank(c.cp.field)) {
								c.value = this.getValueByAttr(postData, c.cp.field);
								if(c.value === null) {
									this.setAttr(postData, c.cp.field, null);
								}
							}
							if(c.cp.filter  && c.cp.filter !== "") {
								c["html_" + c.cp.field] = window.KeeFormatters[c.cp.filter](this.getValueByAttr(postData, c.cp.field), postData);
							}
							if(c.cp.canAdd !== true) {
								if(this.isNotBlank(c.value)) {
									//console.log(c.value);
									if(typeof c.value=="object")
									{
										// if(c.child ) {
										// 	this.initComponentValue(c.child, c);
										// }
									}
									else
									{
										let childFormData = JSON.parse(c.value);
										if(c.child ) {
											this.initComponentValue(c.child, childFormData);
										}
									}
									
								}
							} else {
								if(this.props.debug !== true) {
									let childFormData = [];
									if(this.isNotBlank(c.value)) {
										childFormData = JSON.parse(c.value);
									}
									if(childFormData === null || childFormData.length === 0) {
										childFormData = [{}]
									}
									c.child = [];
									for(let m = 0; m < childFormData.length; m++) {
										let row = childFormData[m];
										let newItem = JSON.parse(JSON.stringify(c.templateForm));
										newItem.id = this.getRandString();
										newItem.alias = c.templateForm.alias + "" + m;
										c.child.push(newItem);
										if(newItem.child ) {
											this.initComponentValue(newItem.child, row, newItem, c);
										}
									}
								}
							}
						} else {
							if(this.isNotBlank(c.cp.field)) {
								c.value = this.getValueByAttr(postData, c.cp.field);
								if(c.value === null) {
									this.setAttr(postData, c.cp.field, null);
								}
							}
							if(c.cp.filter ) {
								c["html_" + c.cp.field] = window.KeeFormatters[c.cp.filter](this.getValueByAttr(postData, c.cp.field), postData);
							}
							if(c.value === null) {
								c.value = c.cp.defaultValue;
							}
							if(c.value===null)
							{
								c.value = "";
							}
							if(c.child ) {
								this.initComponentValue(c.child, postData);
							}
						}
					}
				}
			}
				validComponents=(componentArray, errorComponents)=> {
				if(componentArray ) {
					for(let i = 0; i < componentArray.length; i++) {
						let c = componentArray[i];
						if(c.visiable === false) {
							continue;
						}
						if(c.error !==true)
						{
						 	this.validValue(c);
						}
						if(c.error === true) {
							errorComponents.push(c);
						}
						if(c.error!==true&& c.type !== 'form' )
						{
							let viewName = this.props.component.viewName;
							if(typeof window.CReactMap[viewName][c.alias]!=="undefined" && window.CReactMap[viewName][c.alias]  && typeof window.CReactMap[viewName][c.alias].valueChange === "function")
							{
								window.CReactMap[viewName][c.alias].valueChange(c);
							}
							if(c.error === true) {
							console.log(c.alias+"校验错误！")
								errorComponents.push(c);
							}
						}
						if(c.child ) {
							this.validComponents(c.child, errorComponents);
						}
					}
				}
			}

				validValue=(item)=> {
				let error = false;
				let errorMsg = "";
				if(item.type === "dateRange") {
					if(item.cp.required  && item.cp.required === true) {
						let str = JSON.stringify(item.value);
						if(str.length < 26 || str.indexOf("N") !== -1) {
							error = true;
							errorMsg = "必填项";
						}
					}
				} else {
					if(item.cp.required  && item.cp.required === true) {
						if(this.isNotBlank(item.value) !== true) {
							error = true;
							errorMsg = "必填项";
						}
					}
				}
				if(item.cp.format  && item.cp.format !== "") {
					if(item.cp.format === "text") {
					}
					if(item.cp.format === "email" && item.value  && item.value !== "" && this.isEmail(item.value) === false) {
						error = true;
						errorMsg = "邮箱格式错误";
					}
					if(item.cp.format === "phone" && item.value  && item.value !== "" && this.isPhone(item.value) === false) {
						error = true;
						errorMsg = "电话格式错误";
					}
					if(item.cp.format === "tel" && item.value  && item.value !== "" && this.isTel(item.value) === false) {
						error = true;
						errorMsg = "手机号格式错误";
					}
					if(item.cp.format === "idcard" && item.value  && item.value !== "" && this.isIdCard(item.value) === false) {
						error = true;
						errorMsg = "身份证格式错误";
					}
					if(item.cp.format === "ip" && item.value  && item.value !== "" && this.isIp(item.value) === false) {
						error = true;
						errorMsg = "IP格式错误";
					}
					if(item.cp.format === "number" && item.value  && item.value !== "" && this.isNumber(item.value) === false) {
						error = true;
						errorMsg = "只能输入数字";
					}
					if(item.cp.format === "float" && item.value  && item.value !== "" && this.isFloat(item.value) === false) {
						error = true;
						errorMsg = "只能输入小数";
					}
					if(item.cp.format === "int" && item.value  && item.value !== "" && this.isInt(item.value) === false) {
						error = true;
						errorMsg = "只能输入正整数";
					}
				}
				if(item.cp.minLength  && item.cp.minLength !== "") {
					if(item.value  && item.value.length < parseInt(item.cp.minLength)) {
						error = true;
						errorMsg += "输入长度最小为" + item.cp.minLength + "个字符";
					}
				}
				if(item.cp.maxLength  && item.cp.maxLength !== "") {
					if(item.value  && item.value.length > parseInt(item.cp.maxLength)) {
						error = true;
						errorMsg += "输入长度最大为" + item.cp.maxLength + "个字符";
					}
				}
				if(item.cp.format === 'number' || item.cp.format === 'float' || item.cp.format === 'int') {
					if(this.isNotBlank(item.cp.min)) {
						if(item.value  && parseInt(item.value) < parseInt(item.cp.min)) {
							error = true;
							errorMsg += "不能小于值" + item.cp.min + "";
						}
					}
					if(this.isNotBlank(item.cp.max)) {
						if(item.value  && parseInt(item.value) > parseInt(item.cp.max)) {
							error = true;
							errorMsg += "不能大于值" + item.cp.max + "";
						}
					}
				}
				item.error = error;
				item.errorMsg = errorMsg;
			}
			validTableComponents=()=>{
				let errorComponents = [];
				if(this.state.gridData ) {
					for(let i = 0; i < this.state.gridData.length; i++) {
						this.validComponents(this.state.gridData[i].component.child, errorComponents);
						
						
					}
				}
				return errorComponents
			}
			getGridFormData=()=> {
				let formGrid = [];
				 
				if(this.state.gridData ) {
					for(let i = 0; i < this.state.gridData.length; i++) {
						
						let item = {};
						if(this.state.gridData[i].component&&this.state.gridData[i].component.child)
						{
							this.updateValueFromComponent(item, this.state.gridData[i].component.child,this.state.gridData[i].id);
						}
						
						formGrid.push(item);
						
					 
					}
				}
				 
				//console.log("getGridFormData：："+JSON.stringify(formGrid));
				return formGrid;
			}
			updateValueFromComponent=(row, child,id)=> {
				if(child ) {
					for(let i = 0; i < child.length; i++) {
						if(this.isNotBlank(child[i].cp.field)) {
							// 如果是一个表单，则需要调用表单的getdata
							
							if(child[i].name=='fs-form')
							{
								 
								console.log("开始获取form的值："+child[i].alias+(id?id:''));
								let formData = window.CReactMap[child[i].viewName][child[i].alias+(id?id:'')].getData();
								
								console.log("开始获取form的值:"+JSON.stringify(formData));
								
								this.setAttr(row, child[i].cp.field, formData);
							}
							else
							if(child[i].name=='fs-table')
							{
								 
								console.log("开始获取form的值："+child[i].alias+(id?id:''));
								let formData = window.CReactMap[child[i].viewName][child[i].alias+(id?id:'')].getGridFormData();
								
								console.log("开始获取form的值:"+JSON.stringify(formData));
								
								this.setAttr(row, child[i].cp.field, formData);
							}
							else
							{
								this.setAttr(row, child[i].cp.field, child[i].value);
							}
							
							
						}
						//else
						{
							this.updateValueFromComponent(row, child[i].child,id);
						}
						
					}
				}
			}
			testMethod=()=> {
				alert("调用测试");
			}
			searchNeedFields=(component)=> {
				if(component.child )
					for(let i = 0; i < component.child.length; i++) {
						let c = component.child[i];
						if(this.isNotBlank(c.cp.field)) {
							this.dtoFields += c.cp.field + ","
						} else {
							this.searchNeedFields(c);
						}
					}
			}
			getSelectedRows=()=> {
				return this.selectedRows;
			}
			convertObjectProp=(target,source,prefix)=>
			{
					for(let p in source)
					{
						if(typeof source[p]!=="object")
						{
							target[prefix+"."+p] = source[p]
						}
						else
						{
							this.convertObjectProp(target,source[p],prefix+"."+p);
						}
					}
			}
			exportTable=(queryFormData,title,callback)=>{
				let that = this;
				this.dtoFields = "&fields=";
				this.searchNeedFields(this.props.component);
				let fields = this.dtoFields;
				if(this.state.myQueryData === null) {
					if(that.props.queryForm ) {
						this.state.myQueryData = that.props.queryForm;
					} else {
						this.state.myQueryData = {};
					}
				}
				if(queryFormData ) {
					this.state.myQueryData = queryFormData;
				}
				if(this.isNotBlank(that.props.component.cp.url) === true) {
					let url = this.props.component.cp.url;
					if(url.indexOf("?") === -1) {
						url = url + "?";
					}
					let fenyeUrl = "";
					if(this.state.myQueryData.sort === null || this.state.myQueryData.sort === "") {
						this.state.myQueryData.sort = "id";
					}
					if(this.state.myQueryData.order === null || this.state.myQueryData.order === "") {
						this.state.myQueryData.order = "desc";
					}
					console.log("执行common grid 查询语句：" + url + fields + fenyeUrl)
					this.doRequest(url + fields + fenyeUrl, function(data) {
						let newData = data;
						if(data instanceof Array )
						{
							  newData = {
								rows:data
							}
						}
						for(let i = 0; i < newData.rows.length; i++) {
								for(let p in newData.rows[i])
								{
									if(typeof newData.rows[i][p]==="object")
									{
										that.convertObjectProp(newData.rows[i],newData.rows[i][p],p);
									}
								}
						}
						
						//that.sendPageEvent("beforeExportData", newData.rows,this.props.component);
						
						if(callback&&typeof callback == 'function')
						{
							callback(newData.rows,this.props.component);
						}
						
						this.doRequest("/excel/download",function(ret){
							if(ret.success)
							{
								that.state.downloadPath = window.fileUrl+"/api/fs/getById?ids="+ret.retData.id+"&filename="+title+".xls";
								setTimeout(function() {
									document.getElementById(that.state.randId + "downlink").click();
								}, 200);
								that.refresh();
							}
						},{
							title:title,
							headersJson:JSON.stringify(that.props.component.child),
							dataRowsJson:JSON.stringify(newData.rows)
						})
					}, this.state.myQueryData);
				}
			}
			query=(queryFormData)=> {
				let that = this;
				this.dtoFields = "&fields=";
				this.searchNeedFields(this.props.component);
				let fields = this.dtoFields;
				if(!this.state.myQueryData ) {
					if(that.props.queryForm ) {
						this.state.myQueryData = that.props.queryForm;
					} else {
						this.state.myQueryData = {};
					}
				}
				if(queryFormData) {
					this.state.myQueryData = queryFormData;
				}
				let url = this.props.component.cp.url;
				 
				if(!url)
				{
					if(this.props.keePage&&this.props.keePage.config&&this.props.keePage.config.entity)
					{
						url = "/"+this.props.keePage.config.entity+"/listData";
					}
				}
				//alert("url2::::"+url);
				if(url) {
					
					if(url.indexOf("?") === -1) {
						url = url + "?";
					}
					let fenyeUrl = "";
					if(this.props.component.cp.isPager === true || this.props.debug === true) {
						fenyeUrl += "&rows=" + that.state.pagination.rows;
						fenyeUrl += "&page=" + that.state.pagination.page;
					}
					if(!this.state.myQueryData.sort ) {
						this.state.myQueryData.sort = "id";
					}
					if(!this.state.myQueryData.order  ) {
						this.state.myQueryData.order = "desc";
					}
					let tempsn = this.getRandString()
					console.log(tempsn+"执行common grid 查询语句：" + url + fields + fenyeUrl)
					this.state.isLoaded = false;
					this.doRequest(url + fields + fenyeUrl, function(data) {
						that.state.isLoaded = true;
						
						console.log(tempsn+"执行common grid 查询语句2：" + url + fields + fenyeUrl)
						
						
						that.sendPageEvent("requestDone", data,url);
						
						
						
						if(data instanceof Array )
						{
							let newData = {
								rows:data
							}
							that.sendPageEvent("getData", newData.rows);

						 
							that.showData(newData.rows);
						}
						else
						{
						  that.state.pagination.total = parseInt(data.total);
							
						  that.sendPageEvent("getData", data.rows);

						
						that.showData(data);
						}
					}, this.state.myQueryData);
					
					this.refresh();
				}
			}
			formatRowData=(row, componentArray)=> {
				if(componentArray ) {
					for(let i = 0; i < componentArray.length; i++) {
						let comp = componentArray[i];
						if(this.isNotBlank(comp.cp.field) && comp.cp  && this.isNotBlank(comp.cp.format)) {
							comp.htmlField = "html_" + comp.cp.field;
							console.log("comp.cp.format:"+comp.cp.format);
							if(window.KeeFormatters[comp.cp.format])
							{
								row[comp.htmlField] = window.KeeFormatters[comp.cp.format](this.getValueByAttr(row, comp.cp.field), row);
							}
						}
						if(comp.child ) {
							this.formatRowData(row, comp.child);
						}
					}
				}
			}
			checkIsCanShow=(row, componentArray)=> {
				if(componentArray ) {
					for(let i = 0; i < componentArray.length; i++) {
						let c = componentArray[i]; // 构建默认值
						this.checkIsCanShow(row, c.child);
					}
				}
			}
			
			getDateFilter=(value,formatter)=>{
			   
						if(!value )
							return "";
						//console.log(value);
						if(!formatter ) {
							return this.formatterDate(value, "yyyy-MM月dd");
						} else {
							return this.formatterDate(value, formatter);
						}
				
					 
			}

			getColumns=()=>{
				// 根据当前组件计算列信息
				let cols = [];

				if(this.props.component.cp.showType=='grid'||this.props.component.cp.showType=='tree')
				{
					let hasFixed = false;
					this.props.component.child.map((item,index)=>{
						if(item.cp.fixed)
						{
							hasFixed =true;
						}
						});
					if(this.props.component.cp.isSn===true)
					{
						cols.push({
							type:'index',
							title:'序号',
							width:'80px',
							key:'sn',
							dataIndex:'sn',
							fixed:hasFixed
							 
						})
					}
					// if(this.props.component.cp.isSn===true)
					// {
					// 	cols.push({
					// 		type:'selection',
					// 		label:''
					// 	})
					// }
					if(this.props.component.cp.isAddOrDelBox==true )
					{
						 
						cols.push({
							
							key:'addordelbox',
							width:'60px',

							render:(text,row,index)=>{
								 return  <div>
											 <span className="fa fa-plus" style={{cursor: 'pointer'}} onClick={()=>this.addRow(row)}></span> &nbsp;
											 <span className="fa fa-minus" style={{cursor: 'pointer'}} onClick={()=>this.removeRow(row)}></span>
										 </div>
							}
						})
					}

					this.props.component.child.map((item,index)=>{
						
						if (this.isNotBlank(item.permission)) {
							if(!window.hasPermission(item.permission)&&this.props.debug != true)
							{
								return ;
							}
						}
						
						
						if(item.cp.isHidden!==true)
						{
							cols.push({
								className:item.cp.className,
								sorter:((item.cp.sortable==true||item.cp.sortable=='true')?'custom':false),
								fixed:(item.cp.fixed==true?(index<=(this.props.component.child.length/2)?'left':'right'):false),
								align:(item.cp.align?item.cp.align:'left'),
								width:(item.cp.width?(item.cp.width + 'px'):''),
								title:item.cp.title,
								dataIndex:(item.cp.field?item.cp.field:''),
								key:(item.cp.field?item.cp.field+index:''+index),
								 ellipsis: {
									 showTitle:true
								 },
								//Function(text, record, index) 
								render:(text,row,index)=>{
									
									//console.log("渲染表格列："+item.cp.title+"：序号："+index+" 备注："+row.comment)
									
									let tableColItems = row.component.child;
									let rowItems = [];
									if(tableColItems)
									{
										tableColItems.map((itemRow,index)=>{
											if(itemRow.id==item.id&&itemRow.child)
											{
												rowItems = itemRow.child;
											}
										})
									}
							
									 return  <div>
									   {
										   item.cp.field&&item.cp.type=='text'&&<div title={this.getAttr(row,item.cp.field)}>{this.getAttr(row,item.cp.field)}</div>
									   }
									   {
									   	   item.cp.field&&item.cp.type=='boolean'&&<div title={''+this.getAttr(row,item.cp.field)}>{this.getAttr(row,item.cp.field)}</div>
									   }
							
									   {
									   	   item.cp.field&&item.cp.type=='date'&&<div title={this.getDateFilter(this.getAttr(row,item.cp.field),item.cp.map.formatter)}>{this.getDateFilter(this.getAttr(row,item.cp.field),item.cp.map.formatter)}</div>
									   }
									   {
									   	   item.cp.field&&item.cp.type=='dict'&&<div color={item.cp.color} title={this.getDictTitle(this.getAttr(row,item.cp.field),item.cp.dictName)}>{this.getDictTitle(this.getAttr(row,item.cp.field),item.cp.dictName)}</div>
									   }
									   
							
							
									   {
										   rowItems&&rowItems.length>0&&<FeasComponents
											 components={rowItems} po={row} onChange={this.getGridFormData}
											  onCommand={this.onCommand} debug={this.props.debug} ></FeasComponents>
							
									   }
							
									 </div>
							
								}
							})
						}
						
					})



				}

				return cols;


			}



			showData=(data)=> {
				let that = this; 
				if(data instanceof Array )
				{
				//console.log("显示数据Array");
				if(data ) {
							let str = JSON.stringify(that.props.component);
							let selectedIds = [];
							for(let i = 0; i < data.length; i++) {
								data[i].component = JSON.parse(str);
								if(!data[i].id)
								{
									data[i].id = this.getRandString();
								}
								
								if(data[i].checked)
								{ 
									selectedIds.push(data[i].id);
								}
								
								that.initComponentValue(data[i].component.child, data[i])
							}
							//console.log("selectedIds222:",selectedIds);
							this.state.selectedRowKeys = selectedIds;
							 
							that.sendPageEvent("beforeShowData", data,this.props.component);
					
							if(that.props.component.cp.showType === 'tree')
							{
								that.listToTree(data);
							}
							
							data = {
								rows:data,
							}
					
							}
			}
			else
			{
			//console.log("显示数据data.rows");
				if(data.rows ) {
							let str = JSON.stringify(that.props.component);
						//	console.log("显示数据data.rows"+data.rows.length);
							
							let selectedIds = "";
							for(let i = 0; i < data.rows.length; i++) {
								data.rows[i].component = JSON.parse(str);
								if(!data.rows[i].id)
								{
									data.rows[i].id = this.getRandString();
								}
							//	console.log("显示数据data.rows"+data.rows[i].checked);
								if(data.rows[i].checked)
								{
							//		console.log("i:"+i); 
									selectedIds.push(data.rows[i].id)
								}
								
								that.initComponentValue(data.rows[i].component.child, data.rows[i])
							}
							
							//console.log("selectedIds:",selectedIds);
							
							this.state.selectedRowKeys = selectedIds;
							
							that.sendPageEvent("beforeShowData", data.rows,this.props.component);
								if(that.props.component.cp.showType === 'tree')
								{
									that.listToTree(data.rows);
								}
							}
			}
				let tstart = (new Date()).valueOf();
				if(typeof window.t0 !== "undefined") {
					console.log("到表格显示耗时：" + (tstart - window.t0) + "毫秒");
				}
				 
				// if(this.props.component.cp.showType === 'tree') {
				// 	for(let i = 0; i < data.length; i++) {
				// 	}
				// 	for(let n = 0; n < data.length; n++) {
				// 		data[n].cid = this.getRandString();
				// 		if(this.props.component.cp.isSn === true) {
				// 			data[n].sn = (that.state.pagination.page - 1) * that.state.pagination.rows + n + 1;
				// 		}
				// 		this.formatRowData(data[n], this.props.component.child);
				// 	}
				// 	if(that.$refs.tableTreeRef ) {
				// 		that.$refs.tableTreeRef.initData(data);
				// 	} else {
				// 		setTimeout(function() {
				// 			that.$refs.tableTreeRef.initData(data);
				// 		}, 500);
				// 	}
				// } else 
				
				 
					if(data.rows ) {
						for(let n = 0; n < data.rows.length; n++) {
							data.rows[n].cid = this.getRandString();
							if(this.props.component.cp.isSn === true) {
								data.rows[n].sn = (that.state.pagination.page - 1) * that.state.pagination.rows + n + 1;
							}
							this.formatRowData(data.rows[n], this.props.component.child);
						}
					}
					if(data.rows )
					{
						this.state.gridData = data.rows;
					}
					else
						this.state.gridData = [];
						
					this.setState({
						gridData:[...this.state.gridData]
					})
						
					this.gridData = this.state.gridData;
				 
				that.state.pagination.total = parseInt(data.total);
				that.state.pagination.totalPage = that.state.pagination.total / that.state.pagination.rows;
				if(that.state.pagination.total % that.state.pagination.rows > 0)
					that.state.pagination.totalPage += 1;
				that.state.pagination.totalPage = parseInt(that.state.pagination.totalPage);
				if(that.state.pagination.totalPage>0&&that.state.pagination.page>that.state.pagination.totalPage)
				{
					that.state.pagination.page = that.state.pagination.totalPage; 
					that.query();
				}
				if(that.returnData ) {
					that.returnData.total = that.state.pagination.total;
					that.returnData.rows = that.state.pagination.rows;
					that.returnData.page = that.state.pagination.page;
					that.returnData.totalPage = that.state.pagination.totalPage;
				}
				setTimeout(function() {
					$("#" + that.state.randId + " tr").removeClass("current-row");
					that.resizeHeight();
				}, 200);
				
				this.refresh();

				 
			}
			handleSizeChange=(current,val)=> {
				//alert("size:"+val);
				this.state.pagination.rows = val;
				this.state.pageSize = val;
				this.query();
			}
			handleCurrentPageChange=(page, pageSize)=> {
				//alert(pageSize);
				if(pageSize)
				{
					this.state.pagination.rows = pageSize;
				}
				
				this.state.currentPage4 = page;
				if(page )
					this.state.pagination.page = page;
				else
					this.state.pagination.page = 1;
				//	alert("this.state.pagination.page:"+this.state.pagination.page);
				this.query();
			}
			resizeHeight=()=> {
				return ;
				let that = this;
				//console.log("调整fs-table的高度")
				if(this.props.component.cp.showType==='card')
				{
					return ;
				}
				{
					if($("#" + that.state.randId).offset() ) {
						let top = $("#" + that.state.randId).offset().top;
						if(top !== 0) {
							that.height = window.innerHeight - top - 50;
							let thisDiv = $("#" + that.state.randId);
							let parent = thisDiv.parent();
							while(true) {
									console.log("parent:" + parent.height() + "   parent.scrollHeight" + $(parent)[0].scrollHeight)
								if(parent.height()>0&&parent.height() < $(parent)[0].scrollHeight) {
									that.height = that.height - ($(parent)[0].scrollHeight - parent.height());
										console.log("that.height:" + that.height);
									break;
								}
								parent = parent.parent();
								if(parent.attr("id") === "feasApp"||parent.attr("id") === "appBuildDiv") {
									break;
								}
							}
							setTimeout(function() {
								let width = $("#" + that.state.randId + " .el-table__header").width();
								if(width % 2 !== 0) {
									$("#" + that.state.randId + " .el-table__header").width(width - 1)
								}
							}, 500);
						}
					}
				}
			}
			handleCurrentRowChange=(val)=> {
				this.sendPageEvent("currentChange", val);
			}
			handleSelectionChange=(rows)=> {
				this.sendPageEvent("selectChange", rows);
				this.selectedRows = rows
			}
			rowDblClick=(row, event)=> {
				//alert("shuagnji");
				this.sendPageEvent("dblclick", row);
				console.log("表格双击事件" + row.id);
			}
			// pagination, filters, sorter, extra: { currentDataSource: [] }
			tableChange=( pagination, filters, sorter, extra)=>{ 
				if(sorter)
				{
					let field = sorter.field;
					let order = sorter.order; 
					if(field&&order)
					{
						this.state.myQueryData.sort = field; 
						this.state.myQueryData.order = (order=="ascend"?"asc":"desc");
						
						this.query();
					}
					else
					{
						this.state.myQueryData.sort = "";
						this.state.myQueryData.order = "desc";
						
						this.query();
					} 
				} 
			}
			headerClick=(column, event)=> {
				if(column.type === "selection")
					return;
				let orderFields = "";
				if(this.props.component.child )
					for(let i = 0; i < this.props.component.child.length; i++) {
						if(this.props.component.child[i].id === column.property) {
							this.sendEvent("activeComponent", this.props.component.child[i]);
						}
					}
			}
			rowClick=(row, event)=> {
				console.log("表格单击事件" + row.id);
				this.sendPageEvent("rowClick", row);
				
				let tableChild = this.refs["gridTableRef"];
				tableChild.toggleRowSelection(row);
			}

  renderDesignTable(){


	  return <div>
			{
				(this.props.component.cp.showType==='grid'||this.props.component.cp.showType==='tree')&&
				<table className={`kee-debug-table`} style={{ width:' 100%',height:this.props.component.cp.minHeight}} >
				<thead>
				    <tr style={{'height':  this.props.component.cp.minHeight}} >
					{
						this.props.component.cp.isSn===true&&
						<td style={{width:'50px'}}   >
				            <div style={{position:' relative',width:' 100%',height:' 100%'}} >
				                <div className={`kee-table-td-title`} style={{'color': (this.props.component.cp.isHeader!==false?'#333':'#ccc')}} >
				                序号
				                </div>
				                <div className={`kee-table-td-body`} >
				                 sn
				                </div>
				            </div>
				        </td>
					}
				    {
						this.props.component.cp.isCheckBox===true&&

						<td style={{width:'35px'}}   >
						    <div style={{position:' relative',width:' 100%',height:' 100%'}} >
						        <div className={`kee-table-td-title`} style={{'color': (this.props.component.cp.isHeader!==false?'#333':'#ccc')}} >
						            <input type="checkbox" >
						            </input>
						        </div>
						        <div className={`kee-table-td-body`} >
						            <input type="checkbox" >
						            </input>
						        </div>
						    </div>
						</td>

					}
				    {
						this.props.component.child.map((item,index)=>{
							
							if (this.isNotBlank(item.permission)) {
								if(!window.hasPermission(item.permission)&&this.props.debug != true)
								{
									return <div></div>;
								}
							}
							if(item.name==='fs-table-col'&&item.cp.fixed===true)
							{
								return <FsTableCol key={item.id+index} component={item} componentTable={this.props.component}
								 onChildRefresh={()=>{this.setState(this.state);}} debug={this.props.debug} ></FsTableCol>
							}

						})
					}

					{
						this.props.component.child.map((item,index)=>{
							if (this.isNotBlank(item.permission)) {
								if(!window.hasPermission(item.permission)&&this.props.debug != true)
								{
									return <div></div>;
								}
							}
							
							if(item.name==='fs-table-col'&&item.cp.fixed!==true)
							{
								return <FsTableCol key={item.id+index} component={item} componentTable={this.props.component}
								 onChildRefresh={()=>{this.setState(this.state); }} debug={this.props.debug} ></FsTableCol>
							}

							})
					}


				    </tr>
					</thead>
				</table>
			}

			{
				this.props.component.cp.showType==='card'&&
				<div style={{minHeight:' 100px'}} >
				    <FeasComponents components={this.props.component.child} po={this.state.queryForm} debug={this.props.debug} >
				    </FeasComponents>
				</div>
			}
			{
				this.props.component.cp.isPager!==false&&<div >
				    <div style={{ marginTop:' 5px'}} >
 
				        <Pagination onSizeChange={this.handleSizeChange} onCurrentChange={this.handleCurrentPageChange}
						currentPage={this.state.currentPage4} pageSizes={this.state.pageSizes} pageSize={this.state.pageSize}
						 layout={'total, sizes, prev, pager, next'}
						total={this.state.pagination.total} >
				        </Pagination>
				    </div>
				</div>
			}
		</div>

  }

  renderTable(){
		//console.log(this.props.component);
	  // 构造一个表格对象进行渲染；

	   let cols = this.getColumns();
	   
	   let hasFixed = false;
	   this.props.component.child.map((item,index)=>{
	   	if(item.cp.fixed)
	   	{
	   		hasFixed =true;
	   	}
	   	});
		let scroll = {};
		
		if(hasFixed)
		{
			scroll.x = (150*this.props.component.child.length)+"px";
			console.log('scroll.xscroll.xscroll.x', scroll.x)
		}
	   
	   if(this.props.component.cp.notShowNoData)
	   {
		   if(!this.state.gridData||this.state.gridData.length==0)
		   {
			   return <div></div>
		   }
	   }
		
	   //console.log("当前表格："+JSON.stringify(cols));
	   console.log("this.props.component.cp.showType:"+this.props.component.cp.showType);
	   //console.log("当前表格："+JSON.stringify(this.state.gridData));
	   //console.log("cols.length="+this.state.columns.length+" this.state.inited="+this.state.inited);
	  return <div >
	 
			  {
				 ( this.props.component.cp.showType=='grid' || this.props.component.cp.showType=='tree') &&<div>
					{
						this.props.component.cp.isAddOrDelBox===true &&(this.state.gridData===null||this.state.gridData.length===0)?<Button type="primary" onClick={()=>{this.addRow()}}
						 size="normal"   >
							<i className={`el-icon-plus`}></i>
				  	  							增加

				      </Button>
					  :
					  <Table  spanMethod={this.state.objectSpanMethod} style={{width:' 100%'}}
					  
						scroll={scroll}
						bordered={this.props.component.cp.bordered}
						lined={this.props.component.cp.lined}
						crossColor={this.props.component.cp.crossColor===true}
						rowSelection={this.props.component.cp.isCheckBox?{
					            type: 'checkbox',
								selectedRowKeys:this.state.selectedRowKeys,
								onSelect:(record, selected, selectedRows, nativeEvent)=>{
									let ids = [];
									console.log(selectedRows);
									for(let i=0;selectedRows&&i<selectedRows.length;i++)
									{
										if(selectedRows[i])
										{
											ids.push(selectedRows[i].id);
										}
										
									}
									
									this.state.selectedRowKeys = ids;
									this.refresh();
									
								},
					            onChange: (selectedRowKeys, selectedRows) => {
									// alert("table:"+selectedRowKeys);
									console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
									let sk = "";
									for(let i=0;i<selectedRows.length;i++)
									{
										if(selectedRows[i])
										{
											if(sk)
											{
												sk+=",";
											}
											sk+=selectedRows[i].id;
										}
									}
									
								  this.sendPageEvent("selectChange", selectedRows,sk); 
					            },
					            getCheckboxProps: record => ({
					              disabled: record.name === 'Disabled User', // Column configuration not to be checked
					              name: record.name,
					            }),
					          }:null}
					  
					  
					 
					  border={true}   height={this.props.component.cp.isPager===true?this.state.height:null}
					  
					  rowKey={'id'}
					  							onHeaderClick={this.headerClick}
												onChange={this.tableChange}
												showHeader={this.props.component.cp.isHeader!==false}
					  							onCurrentChange={this.handleCurrentRowChange}
					  							onSelectionChange={this.handleSelectionChange}
					  							 pagination={false}
												 loading = {!this.state.isLoaded}
												 dataSource={this.state.gridData}
												 columns={ cols}>



					  </Table>
					}


				  </div>
			  }






			{
				this.props.component.cp.showType==='card'&&<Layout.Row className={`el-row`}>
				
				{
					this.state.gridData.map((row,index)=>{
						
						return <FeasComponents 
						cpstyle={this.props.component.style} 
						key={row.id} 
						components={row.component.child} 
						po={row} 
						debug={this.props.debug} >
						</FeasComponents>
						
						})
				}
				
					
				
				    
				</Layout.Row>
			}

 
			{
				this.props.component.cp.isPager!==false&&this.props.component.cp.showType!=='tree'&&
				<div style={{ textAlign:'left',marginTop:' 15px'}} >
				 
				{
					this.state.pagination.total>0&&<Pagination   total={this.state.pagination.total}
				 onChange={this.handleCurrentPageChange}
				 onShowSizeChange={this.handleSizeChange}
				 
				 />
				  
				 
				}
				
				 
				</div>
			}
 
	</div>

  }
  
  shouldComponentUpdate(nextProps, nextState) {
  	
 
   
  		
  	// if((JSON.stringify(this.props)+JSON.stringify(this.state)) ===(JSON.stringify(nextState)+JSON.stringify(nextProps)))
  	// {
  	// 	console.log("重新渲染表格fstable经过计算，不需要更新");
  	// 	return false;
  	// } 
  	// console.log("fstable计算 需要渲染");
  	return true;
  
     //  if (nextState.componentTypes===this.state.componentTypes) {
  
     //    return false;
     //  }
     //  return true;
  }
  

  render(){
	  
	  // console.log("重新渲染表格fstable"+this.state.randId)
  return(

<div  style={{ position: 'relative'}} id={this.state.randId} >

	{
		this.props.debug==true? this.renderDesignTable():this.renderTable()
	}
    <div style={{display:' none'}} >
        <a id={this.state.randId+'downlink'} href={this.state.downloadPath} download={this.state.randId+'.xls'} >
         下载
        </a>
    </div>
</div>
  );}
 }
